import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { throwError } from 'rxjs';

import { ConfigService } from '@finder/core/config.service';
import { SfccConnector } from './sfcc-connector';
import {
    SfccCartAddProduct,
    SfccCartCreateWithProduct,
    SfccCartRemoveProduct,
    SfccCartUpdateProduct
} from './sfcc.interface';
import { LiveCommerceCustomError } from '@finder/shared/features/live-commerce/live-commerce.interface';

@Injectable({
    providedIn: 'root',
})
export class SfccGatedConnectorService extends SfccConnector {
    constructor(
        protected config: ConfigService,
        protected http: HttpClient,
    ) {
        super(config, http);
    }

    auth() {
        return throwError(new Error('Not Implemented'));
    }

    addProducts(skus: string[]) {
        // Create the body
        const body = { products: [] };
        skus.forEach(sku => body.products.push({ productId: sku }));

        // Set options
        const options = {
            headers: new HttpHeaders({
                'content-type': 'application/json',
            }),
            withCredentials: true,
        };

        // Get the URL and call
        const apiBase = this.getApiBase();
        const url = `${apiBase}/shop/gated-cart`;
        return this.http.post(url, body, options) as Observable<boolean | LiveCommerceCustomError>;
    }

    addProduct(product: SfccCartAddProduct) {
        return throwError(new Error('Not Implemented'));
    }

    updateProduct(product: SfccCartUpdateProduct) {
        return throwError(new Error('Not Implemented'));
    }

    removeProduct(product: SfccCartRemoveProduct) {
        return throwError(new Error('Not Implemented'));
    }

    createCartWithProduct(product: SfccCartCreateWithProduct) {
        return throwError(new Error('Not Implemented'));
    }
}
